import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "header-time" }
const _hoisted_5 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_6 = { class: "call-row" }
const _hoisted_7 = { class: "call-row" }
const _hoisted_8 = { class: "call-row" }
const _hoisted_9 = ["onClick"]

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'JobCallsModal',
  props: {
    baseUrl: {}
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const jobCalls = ref<any[]>([])
const isModalVisible = ref(false)
const callTypes = ref<any[]>([])
const isEditMode = ref(false)
const currentJobId = ref(0)

const emit = __emit

function showModal() {
  isModalVisible.value = true
  document.body.classList.add("modal-open")
}

function closeModal() {
  isModalVisible.value = false
  document.body.classList.remove("modal-open")
  emit('close')
}

function openForAdd() {
  isEditMode.value = false
  currentJobId.value = 0
  jobCalls.value = []
  showModal()
}

function openForEdit(jobCallsData: any[]) {
  isEditMode.value = true
  jobCalls.value = Array.isArray(jobCallsData) ? jobCallsData : []
  showModal()
}

function getCallTypeName(id: number): string {
  const type = callTypes.value.find((ct: any) => ct.id === id)
  return type?.name || id.toString()
}

function formatTime(dateString: string): string {
  if (!dateString) return 'N/A'
  try {
    const date = new Date(dateString)
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  } catch {
    return dateString
  }
}

function getCurrentTime(): string {
  return new Date().toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
}

function extractCoordinates(location: string): { lat: number; lng: number } | null {
  if (!location) return null
  const parts = location.split(',').map(s => s.trim())
  if (parts.length >= 2) {
    const lng = parseFloat(parts[0])
    const lat = parseFloat(parts[1])
    if (!isNaN(lat) && !isNaN(lng)) return { lat, lng }
  }
  return null
}

// CHANGED: Show address from remarks instead of coordinates
function getLocationDisplay(jobCall: any): string {
  // If remarks has a readable address, use it
  if (jobCall.remarks && jobCall.remarks.length > 0) {
    return jobCall.remarks
  }
  
  // Fallback to coordinates if no remarks
  const coords = extractCoordinates(jobCall.location)
  if (coords) {
    return `${coords.lat.toFixed(6)}, ${coords.lng.toFixed(6)}`
  }
  return jobCall.location || 'N/A'
}

function openMap(jobCall: any) {
  const coords = extractCoordinates(jobCall.location)
  if (!coords) {
    alert('No coordinates available')
    return
  }
  window.open(`https://www.google.com/maps?q=${coords.lat},${coords.lng}`, '_blank')
}

// Load callTypes from localStorage
const stored = localStorage.getItem("callTypes")
if (stored) {
  try {
    callTypes.value = JSON.parse(stored)
  } catch (e) {
    console.error("Failed to parse callTypes:", e)
  }
}

__expose({ openForAdd, openForEdit, closeModal })

return (_ctx: any,_cache: any) => {
  return (isModalVisible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-backdrop",
          onClick: closeModal
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Job Calls", -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(getCurrentTime()), 1)
            ]),
            _createElementVNode("button", { onClick: closeModal }, "×")
          ]),
          (jobCalls.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("p", null, "No calls found", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobCalls.value, (jobCall) => {
            return (_openBlock(), _createElementBlock("div", {
              key: jobCall.id,
              class: "call-item"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("label", null, "Call Type", -1)),
                _createElementVNode("span", null, _toDisplayString(getCallTypeName(jobCall.callTypeId)), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("label", null, "Call Time", -1)),
                _createElementVNode("span", null, _toDisplayString(formatTime(jobCall.callTime)), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[5] || (_cache[5] = _createElementVNode("label", null, "Location", -1)),
                _createElementVNode("span", {
                  class: "location-link",
                  onClick: ($event: any) => (openMap(jobCall))
                }, [
                  _createTextVNode(_toDisplayString(getLocationDisplay(jobCall)) + " ", 1),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "map-icon" }, "📍", -1))
                ], 8, _hoisted_9)
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})